import { graphqlOperation } from 'aws-amplify';
import {
  bulkDeleteUser,
  createProducerUser,
  deleteProducerUser,
  updateProducerUser,
} from '../../graphql/mutations';
import { graphql } from '../../utils/api';

const usersStore = {
  state: {
    users: [],
  },
  reducers: {
    SET_USERS(state, payload) {
      return {
        ...state,
        users: payload,
      };
    },
  },
  effects: (dispatch) => ({
    setUsers(payload) {
      dispatch.users.SET_USERS(payload);
    },
    addUser(user, state) {
      dispatch.users.SET_USERS([...state.users.users, user]);
    },

    async createUser(payload, rootState) {
      const {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        userRole,
        storeIds,
        ...rest
      } = payload.values;
      const mutationInput = {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        userRole,
        storeIds,
        ...rest,
      };
      const addRes = await graphql(
        graphqlOperation(createProducerUser, {
          input: mutationInput,
        }),
      );

      console.log('[storesReducer]::[createUser]:', addRes);
      const newUsers = [...rootState.users.users, mutationInput];
      dispatch.users.SET_USERS(newUsers);
    },
    async updateUser(payload, rootState) {
      const {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        role,
        ...rest
      } = payload.values;
      const mutationInput = {
        userId,
        firstName,
        middleName,
        lastName,
        email,
        phoneNumber,
        role,
        ...rest,
      };
      const addRes = await graphql(
        graphqlOperation(updateProducerUser, {
          input: mutationInput,
        }),
      );

      console.log('[storesReducer]::[createUser]:', addRes);
      const newUsers = [...rootState.users.users, mutationInput];
      dispatch.users.SET_USERS(newUsers);
    },
    async deleteUser(payload, rootState) {
      const { userId } = payload;

      const addRes = await graphql(
        graphqlOperation(deleteProducerUser, {
          input: { userId: payload },
        }),
      );

      console.log('[storesReducer]::[deleteUser]:', addRes);
      const newUsers = [];
      rootState.users.users.map((userItem) => {
        if (userItem.userId !== userId) {
          newUsers.push(userItem);
        }
      });
      dispatch.users.SET_USERS(newUsers);
    },
    async bulkDeleteUser(payload, rootState) {
      const mutationInput = { userIds: payload };

      const addRes = await graphql(
        graphqlOperation(bulkDeleteUser, {
          input: mutationInput,
        }),
      );

      console.log('[storesReducer]::[bulkDeleteUser]:', addRes);
      return addRes;
    },
  }),
};

export default usersStore;
